import { __decorate, __metadata } from "tslib";
/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify resolution of all matches to a key.
 */
var AllResolver = /** @class */ (function () {
    /**
     * Creates an instance of the All class.
     * @param key The key to lazily resolve all matches for.
     */
    function AllResolver(key) {
        this._key = key;
    }
    AllResolver_1 = AllResolver;
    /**
     * Creates an All Resolver for the supplied key.
     * @param key The key to resolve all instances for.
     * @return Returns an instance of All for the key.
     */
    AllResolver.of = function (key) {
        return new AllResolver_1(key);
    };
    /**
     * Called by the container to resolve all matching dependencies as an array of instances.
     * @param container The container to resolve from.
     * @return Returns an array of all matching instances.
     */
    AllResolver.prototype.get = function (container, key) {
        return container.getAll(this._key);
    };
    var AllResolver_1;
    AllResolver = AllResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object])
    ], AllResolver);
    return AllResolver;
}());
export { AllResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxsUmVzb2x2ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBbGxSZXNvbHZlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7O0dBS0c7QUFDSCxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUl6RDs7R0FFRztBQUVIO0lBYUk7OztPQUdHO0lBQ0gscUJBQW1CLEdBQVc7UUFDMUIsSUFBSSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7SUFDcEIsQ0FBQztvQkFuQlEsV0FBVztJQUNwQjs7OztPQUlHO0lBQ1csY0FBRSxHQUFoQixVQUFvQixHQUFXO1FBQzNCLE9BQU8sSUFBSSxhQUFXLENBQUksR0FBRyxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQWFEOzs7O09BSUc7SUFDSSx5QkFBRyxHQUFWLFVBQVcsU0FBb0IsRUFBRSxHQUFXO1FBQ3hDLE9BQU8sU0FBUyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkMsQ0FBQzs7SUE1QlEsV0FBVztRQUR2QixpQkFBaUI7O09BQ0wsV0FBVyxDQTZCdkI7SUFBRCxrQkFBQztDQUFBLEFBN0JELElBNkJDO1NBN0JZLFdBQVcifQ==